module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/simple-peer/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 323
// module chunks = 0